export default __webpack_public_path__ + "static/YouYou_colour-9557d58c10d8bda2242e5e7192c436b5.jpg";